// extracted by css-extract-rspack-plugin
export default {"wrapper":"_82b0c8c3","img":"_e29c153","imgWrapper":"_ef1896e0","overlay":"_47e0cc8a"};